/* global LiveLineChart */

FD.Page = function () {
    'use strict';

    const me = {
        init: function () {
            setInterval(function () {
                $.fdAjax({
                    url: '/Framework/Chart/GetRandomData?count=7', // HACK: this url should be set in razor
                    callback: function (result) {
                        LiveLineChart.data.datasets[0].data = result.data;
                        LiveLineChart.update();
                    }
                });
            }, 5000);
        }
    };

    return Object.assign({}, FD.Page, me);
}();